<template>
  <el-dialog class="demand_model_dialog" top="5vh" center :title="newTitle" width="80%" :before-close="handleClose"
    :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex;">
        <el-form-item label="录入区间" prop="serach_plt_time" :label-width="formLabelWidth">
          <el-date-picker
              v-model="form.serach_plt_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期" />
        </el-form-item>
      </div>
      <el-form-item label="阶段现状" prop="stageCondition" :label-width="formLabelWidth">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 16 }"
                  placeholder="请输入阶段现状" v-model="form.stageCondition">
        </el-input>
      </el-form-item>
      <el-form-item label="阶段进展" prop="stageProgress" :label-width="formLabelWidth">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 16 }"
                  placeholder="请输入阶段进展" v-model="form.stageProgress">
        </el-input>
      </el-form-item>
      <el-form-item label="推进计划" prop="promotePlan" :label-width="formLabelWidth">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 16 }"
                  placeholder="请输入推进计划" v-model="form.promotePlan">
        </el-input>
      </el-form-item>
      <el-form-item label="风险预警" prop="riskWarning" :label-width="formLabelWidth">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 16 }"
                  placeholder="请输入风险预警" v-model="form.riskWarning">
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="details" :label-width="formLabelWidth">
      <HistoryRecord :recordList = recordList></HistoryRecord>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="warning" :loading="loading.submit" @click="onSubmit">提 交</el-button>
      <el-button type="success" @click="handleClose">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import Task from './task.vue'
import Comment from './comment.vue'
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"
import {
  postDevOpsSpaceCreateProducerApi,
  postDevOpsSpaceUpdateProducerApi,
  postDevOpsSpaceDeleteProducerApi,
  getDevOpsSpaceProducerDetailApi,
  getDevOpsSpaceProducerListApi,
  postDevOpsSpaceDeleteTaskApi,
  postDevOpsSpaceCreateReviewerApi,
  postDevOpsSpaceUpdateReviewerApi,
  postDevOpsSpaceReviewerRollbackApi,
  postDevOpsSpaceUserPmEditStatusApi,
  postDevOpsSpaceUserPmEditReviewerApi, postDevOpsSpaceCreateProjectRecordApi, getDevOpsSpaceFindProjectRecordApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import HistoryRecord from "./historyRecord.vue";
export default {
  components: { Editor, Comment, Task, HistoryRecord },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    tabid: {
      type: String,
      default: '',
    },
    back: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        creator: '',
        projectId: '',
        startDate: '',
        endDate: '',
        stageCondition: '',
        stageProgress: '',
        promotePlan: '',
        riskWarning: '',
        name: '',
        serach_plt_time: [],
      },
      pStatusForm:{
        op_status:'',
        p_status:'',
        change_reason:'',
        back_status:false,
        id:''
      },
      reviewerForm:{
        reviewer:'',
        loading:false
      },
      pStatusRules:{
        p_status:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        change_reason:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      rules: {
        serach_plt_time: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
      },
      tasks: [],
      dialogVisibleTask: false,
      dialogVisiblePStatus:false,
      dialogVisibleReviwer: false,
      step: 1,
      formTaskInfo: {},
      reviewerSelect: [],
      showDetails: false,
        // 判断是否是产品
      isUserPm:false,
      recordList: {},
    };
  },
  async mounted() {
    const { id = '',name = '' } = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    //this.$set(this.form, 'creator', username);
    this.$set(this.form, 'name', name);
    this.$set(this.form, 'projectId', id);
    let nowday = new Date().getDay();
    let day = nowday || 7;
    let start_date = new Date(this.$moment(new Date()).format("YYYY-MM-DD")).getTime() - 60 * 60 * 24 * 1000 * (day - 1);
    let end_date = start_date + 60 * 60 * 24 * 1000 * 4;
    let choose_start_time = this.formatDate(start_date);
    let choose_end_time = this.formatDate(end_date);
    this.form.serach_plt_time = [choose_start_time,choose_end_time];
    this.init(id);
  },
  computed: {
    ...mapState(
      {
        allSelect: (state) => state.devOps.ALLSELECT,
      }
    ),
    newTitle() {
        return '记录-' + this.form.name;
    },
    // 判断需求状态
    isPStatus() {
      const { p_status } = this.form;
      if(p_status === 'p_stop' ||p_status === 'p_canceled') return false;
      return true
    },
    // 判断是否是运维空间
    isOperatorSpace() {
      return this.form.space === 'operatorSpace';
    },
    // 判断是否是技术负责人
    isReviewer() {
      return this.form.username === this.form.reviewer;
    },
    isAdmin() {
      return this.form.is_admin;
    },
    // 判断是否是新建
    isUpdata() {
      return this.form.id;
    },
    // 需求部分不可编辑
    isProjectDisabled() {
      //  方案状态  开发团队 项目体系 需求描述 PRD链接 需求人员 产品人员 技术负责人 优先级 期望上线日期 --- 创建需求可编辑  未评审需根据step判断 评审中不可编辑 已评审不可编辑
      if (this.isOperatorSpace) { // 如果是产品空间直接不可以编辑
        return true
      }
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 1) return true;
        if (this.isNotReviewed) { // 未评审
          if (this.isAdmin) return false;
          if (!this.isUserPm) return true;
        }
        if (this.isUnderReview) { // 评审中
          return true
        }
        if (this.isReviewed) { // 已评审
          return true
        }
      }
      return false; // 默认可编辑
    },
    // 展示技术负责人部分的表单
    showReviewedForm() {
      if (this.isUnderReview) { // 评审中
        return true
      }
      if (this.isReviewed) { // 已评审
        return true
      }
      return false
    },
    // 判断技术负责人部分是否可编辑
    isReviewedDisabled() {
      const { username, reviewer } = this.form;
      if (this.isOperatorSpace) {
        return true
      }
      if (this.isAdmin) return false;
      if (username === reviewer) return false;  // 技术负责人展示
      return true
    },
    // 判断是否展示任务添加
    showTaskAdd() {
      const { p_status, username, reviewer } = this.form;
      if ((this.isReviewed || this.isHistoryReviewed) && p_status !== 'p_notstart' && p_status !== 'p_indesign') {
        if (this.isAdmin) return true; // 管理元展示
        if (username === reviewer) return true;  // 技术负责人展示
      }
      return false;
    },
    // 判断是否展示任务列表
    showTaskList() {
      return (this.isReviewed || this.isHistoryReviewed) && this.tasks.length;
    },
    // 判断任务部分是否可编辑
    isTaskDisabled() {
      const { username, reviewer } = this.form;
      if (!this.isHistoryReviewed && !this.isReviewed) return true;
      if (this.isAdmin) return false; // 管理元展示
      if (username === reviewer) return false;  // 技术负责人展示
      return true;
    },
    //参会人员中文
    participantsStrEn() {
      let str = ''
      this.form.participants.forEach(item => {
        str += this.allSelect.TEXTUSERSEN[item] + ' '
      })
      return str;
    },
    // 是否是历史需求已评审
    isHistoryReviewed() {
      return this.form.reviewed_status === 'history_reviewed'
    },
    // 判断是否是评审中 not_reviewed under_review reviewed history_reviewed
    isUnderReview() {
      return this.form.reviewed_status === 'under_review'
    },
    // 判断是否是未评审
    isNotReviewed() {
      return this.form.reviewed_status === 'not_reviewed'
    },
    // 判断是否是已评审
    isReviewed() {
      return this.form.reviewed_status === 'reviewed'
    },
    showEdit() {
      if (this.isOperatorSpace) {
        return false
      }
      if (this.isNotReviewed) {//未评审 非管理员 非产品人员
        if (this.isAdmin) {
          return this.step === 1
        }
      }
      if (this.isUnderReview) {
        return false
      }
      if (this.isReviewed) { // 已完成 非管理员 非技术负责人
        if (this.isAdmin) {
          return this.step === 1
        }
        if (this.form.username === this.form.reviewer) {
          return this.step === 1
        }
      }
      if (this.isHistoryReviewed) {
        return false;
      }
      return false;
    },
    showSubmit() {
      if (this.isOperatorSpace) {
        return false
      }
      if (this.isNotReviewed) {//未评审 非管理员 非产品人员
        if (this.isAdmin) {
          return this.step === 2
        }

      }
      if (this.isUnderReview) {
        return false
      }
      if (this.isReviewed) { // 已完成 非管理员 非技术负责人
        if (this.isAdmin) {
          return this.step === 2
        }
        if (this.form.username === this.form.reviewer) {
          return this.step === 2
        }
      }
      if (this.isHistoryReviewed) {
        return false;
      }
      return this.step === 2;
    },
    TEXTREVIEWSTATUS() {
      return this.form.reviewed_status && this.allSelect.TEXTREVIEWSTATUS && this.allSelect.TEXTREVIEWSTATUS[this.form.reviewed_status]
    }
  },
  methods: {
    openDialogVisibleReviwer(){
      this.reviewerForm.reviewer = this.form.reviewer
      this.dialogVisibleReviwer = true
    },
    // 获取记录列表
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceFindProjectRecordApi({ projectId:id });
        const info = ret.data || {};
        this.recordList = info;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }
    },
    async queryChangePStatus(back_status){
        try {
          let params =  { ...this.pStatusForm, id:this.form.id ,back_status,op_status:this.form.p_status}
          const ret = await postDevOpsSpaceUserPmEditStatusApi(params)
          if(ret.status === 'success'){
            this.dialogVisiblePStatus = false;
            this.$notify({
              message: ret.data.msg || "变更成功",
              type: "success",
            })
            this.hideDialogVisible()
          }else{
            this.$notify({
              message: ret.data.msg || "变更失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "变更失败",
            type: "error",
          })
        }
    },
    // 评审中 技术负责人回退
    onRollback(){
        this.$confirm('此操作将回退到上一步, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(async () => {
            try {
              this.$set(this.loading, 'submitRollBack', true)
              const ret = await postDevOpsSpaceReviewerRollbackApi({id:this.form.id})
              if (ret.status === 'success') {
                this.$notify({
                  message: '回退成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                }, 500)
              } else {
                this.$notify({
                  message: ret.data.msg || "回退失败",
                  type: "error",
                })
              }
            } catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
            } finally {
              this.loading.submitRollBack = false;
            }
          })
    },
    changeProjectSystem(val) {
      this.form.project_system = val;
      this.form.reviewer = ''
      try {
        const list = this.allSelect?.TEXTECHNICALREVIEW[val] || [];
        if (list && list.length) {
          this.$set(this.form, 'reviewer', list[0][1])
        }
        this.reviewerSelect = list;
      } catch (error) { }
    },
    changeStep() {
      this.step = 2;
    },
    // 添加任务
    onAddTask(type, row) {
      const {is_admin,reviewer,reviewed_status,id,title,user_pm,link_to,re_details,p_link} = this.form;
      if (type === 'add') {
        this.formTaskInfo = { is_admin, reviewer,user_pm, reviewed_status, link_to: this.formatLink(link_to),re_details,p_link: this.formatLink(p_link),taskInfo: { pid: id, title } }
      }
      if (type === 'copy') {
        this.formTaskInfo = {
          ...this.form,
          link_to: this.formatLink(link_to),
          p_link: this.formatLink(p_link),
          taskInfo: {
            ...row,
            pid: id,
            user_pm,
            openType: 'copy'
          }
        }
      }
      this.dialogVisibleTask = true;
    },
    // 链接判断
    formatLink(val){
      if(!val) return '';
      return val.startsWith('http') ? val :`http://${val}`
    },
    // 技术负责人提交
    async onSubmitReviewed(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.form.p_status !== 'p_finish') {
            this.$notify({
              message: '请将方案状态修改到已完成',
              type: "warning",
            })
            return
          }
          this.$confirm('此操作将进行到下一步, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(async () => {
            try {
              this.$set(this.loading, 'submitReviewed', true)
              if (this.step === 2 && action === 'create') {
                await this.onSubmit(false)
              }
              const {
                id = "",
                reviewer = '',
                user_pm = '',
                technical_difficulty = '',
                participants = '',
                link_to = '',
                re_details = '',
                p_link = ''
              } = this.form;
              const param = { id, reviewer, user_pm};
              const ret = action === 'create' ? await postDevOpsSpaceCreateReviewerApi({...param, p_link:this.formatLink(p_link)}) : await postDevOpsSpaceUpdateReviewerApi({ ...param, technical_difficulty, participants: String(participants), re_details,link_to:this.formatLink(link_to),  })
              if (ret.status === 'success') {
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                }, 500)
              } else {
                this.$notify({
                  message: ret.data.msg || "提交失败",
                  type: "error",
                })
              }
            } catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
            } finally {
              this.loading.submitReviewed = false;
            }
          })
        }
      })
    },
    // 需求提交
    async onSubmit(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    // 确定并提交技术评审
    async onConfirmSubmitReviewed(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if(!this.form.p_link){
            this.$notify({
              message: "PRD链接必填",
              type: "warning",
            });
            return ;
          }
          if (this.form.p_status !== 'p_finish') {
            this.$notify({
              message: '请将方案状态修改到已完成',
              type: "warning",
            })
            return
          }
          const {
            title = "",
            details = "",
            demander = [],
            user_pm = [],
            plt = "",
            priority = "",
            tag = [],
            p_status = "",
            p_link = '',
            p_category = [],
            project_system = [],
            reviewer = '',
            link_to = '',
            re_details = '',
            technical_difficulty = '',
            participants = [],
            reviewed_status = ''
          } = this.form;
          const param = { title, details, demander: demander.toString(), user_pm: user_pm.toString(), p_category: p_category.toString(), project_system: project_system.toString(), project_status: p_status, priority, tag: tag.toString(), reviewer, plt, p_link: this.formatLink(p_link) };
          // 创建
          const ret = await postDevOpsSpaceCreateProducerApi(param);
          if (ret.status === 'success') {
            if(ret.data){
              const {id = ""} = ret.data;
              const r_params = {
                id: id,
                reviewer: reviewer,
                user_pm: user_pm
              }
              const result = await postDevOpsSpaceCreateReviewerApi({...r_params, p_link:this.formatLink(p_link)})
              if(result.status === 'success'){
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                }, 500)
              }else{
                this.$notify({
                  message: result.data.msg || "提交失败",
                  type: "error",
                })
                this.handleClose()
              }
            }

          }else {
            this.$notify({
              message: ret?.data?.msg || "失败",
              type: "error",
            })
          }
          //this.moduleSubmit(close)
        }
      });
    },
    // 调用需求提交接口
    async moduleSubmit(close = true){
      try {
            close && this.$set(this.loading, 'submit', true)
            const param = this.form;
            this.form.startDate='';
            this.form.endDate='';
            if(this.form.serach_plt_time){
              if(this.form.serach_plt_time[0]){
                this.form.startDate=this.form.serach_plt_time[0];
              }
              if(this.form.serach_plt_time[1]){
                this.form.endDate=this.form.serach_plt_time[1];
              }
            }
            const ret = await postDevOpsSpaceCreateProjectRecordApi(this.form);
            if (ret.status === 'success') {
              if (close) {
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                    this.handleClose()

                }, 500)
              }
            } else {
              this.$notify({
                message: ret?.data || "失败",
                type: "error",
              })
            }
          } catch (error) {
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          } finally {
            this.loading.submit = false;
          }
    },
    formatDate(time) {
      let date = new Date(time);
      let myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = '0' + mymonth;
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday;
      }
      return (myyear + '-' + mymonth + '-' + myweekday);
    },
    // 修复 input 框输入 乱聚焦到富文本的问题
    focusLinkFn(refName) {
      setTimeout(() => {
        this.$refs[refName].focus()
      })
    },
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    // 打开新的模块
    linkToModel(row, type) {
      // if (type !== 'task') return;
      let newRow = {
        ...this.form,
        taskInfo: {
          ...row,
          pid: this.form.id,
          user_pm: this.form.user_pm,
          p_status: this.form.p_status
        }
      }
      this.showDialogVisible(type, newRow)
    },
    // 关闭弹窗
    handleClose(step) {
      if(this.back){
        this.hideDialogVisible('project')
      }else{
        this.hideDialogVisible(step)
      }
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.details = val;
    },
    // 删除任务
    onDeleteTask(row) {
      this.$confirm("此操作将删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'task' + row.id, true)
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: row.id,
          });
          if (res.status === "success") {
            this.queryTaskList(this.form.id)
          } else {
            this.$notify({
              message: res?.data?.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['task' + row.id] = false;
        }
      });
    },
    // 关闭任务弹窗
    handleTaskClose() {
      this.dialogVisibleTask = false;
      this.queryTaskList(this.form.id)
    },
    // 任务列表 需求进度 需求状态
    async queryTaskList(id) {
      try {
        const res = await getDevOpsSpaceProducerListApi({ title: id });
        this.tasks = res?.data[0]?.tasks || []
        this.form.p_issue_status = res?.data[0]?.p_issue_status || ''
      } catch (error) {
        console.error(error)
      }
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}

.popperDom {
  max-width: 240px;
}
</style>
